import Route from '@ember/routing/route';

export default class SsoConfirmEmailRoute extends Route {}
